export default __webpack_public_path__ + "static/media/InvestmentBlack.1a5de567.svg";